import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { TradeCategory } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { TradeService } from 'src/app/services/trade.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-trade-categories-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './trade-categories-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TradeCategoriesGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private TradeService: TradeService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'TradeCategory';
    this.rowModelType = 'serverSide';

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.TradeService.getTradeCategories(queryObject),
          this.TradeService.getTradeCategoriesCount(countQueryObject)
        ]).subscribe({
          next: ([Categories, categoryCount]: [TradeCategory[], number]) => {
            const successObject: {
              rowData: TradeCategory[];
              rowCount: number;
            } = {
              rowData: Categories,
              rowCount: categoryCount
            };

            params.success(successObject);
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
